import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "ic-close_d913bf6e4d59545823b87387e3626c6c",
  "use": "ic-close_d913bf6e4d59545823b87387e3626c6c-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 16 16\" id=\"ic-close_d913bf6e4d59545823b87387e3626c6c\">\n    <path fill=\"#4B4B4B\" d=\"M16 1.6L14.4 0 8 6.4 1.6 0 0 1.6 6.4 8 0 14.4 1.6 16 8 9.6l6.4 6.4 1.6-1.6L9.6 8 16 1.6z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id